<template>
  <section class="plan-selector">
    <div class="plan-header">
      <h2 class="title">
        Pick a Plan
        <span class="play-icon"
        ><img src="@/assets/icons/play-icon.svg" alt=""
        /></span>
      </h2>
      <div class="step-badge">Step 3/5</div>
    </div>

    <div class="plans">
      <label class="plan-card">
        <input type="radio" name="hot-plan" value="hot" v-model="selected"/>
        <div class="card-inner">
          <div class="top">
            <div class="plan-info">
              <img src="@/assets/icons/hot-plan.svg" alt="Temperature Icon"/>
              <h3>Hot Plan</h3>
            </div>
            <div class="plan-right">
              <p>
                Access our full training library, including compliance courses
                like Food & Alcohol and Sexual Harassment.
              </p>
              <div class="d-flex flex-column price-container">
                <div class="price">$1.49 - 1.99/</div>
                <div class="sub">Per user, per month.</div>
              </div>
            </div>
          </div>

          <div class="plan-controls">
            <div class="control-grid">
              <div class="control">
                <label>Number of Users <span class="required">*</span></label>
                <div class="number-input">
                  <input type="number" v-model.number="controls.users" @input="checkEnterpriseLimit()"/>
                </div>
              </div>
              <div class="control">
                <label
                >Number of Locations <span class="required">*</span></label
                >
                <div class="number-input">
                  <input type="number" v-model.number="controls.locations" @input="checkEnterpriseLimit()"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </label>


      <label class="plan-card popular">
        <input
          type="radio"
          name="sizzlng-plan"
          value="sizzling"
          v-model="selected"
        />
        <div class="card-inner">
          <div class="top">
            <div class="plan-info">
              <img src="@/assets/icons/sizzle-plan.svg" alt="Fire Icon"/>
              <h3>Sizzling Plan</h3>
            </div>
            <div class="plan-right">
              <p>
                Access our full training library, including compliance courses
                like Food & Alcohol and Sexual Harassment.
              </p>
              <div class="d-flex flex-column price-container">
                <div class="price">$1.99 - 2.49/</div>
                <div class="sub">Per user, per month.</div>
              </div>
            </div>
          </div>
          <div class="badge">Popular</div>
          <!-- plan control -->
          <div class="plan-controls">
            <div class="control-grid">
              <div class="control">
                <label>Number of Users <span class="required">*</span></label>
                <div class="number-input">
<!--                  <button type="button" @click.prevent="decrement('users')">-->
<!--                    <img src="@/assets/icons/minus.svg" alt="Decreament Icon"/>-->
<!--                  </button>-->
                  <input type="number" v-model.number="controls.users" @input="checkEnterpriseLimit()"/>
<!--                  <button type="button" @click.prevent="increment('users')">-->
<!--                    <img src="@/assets/icons/plus.svg" alt="Increament Icon"/>-->
<!--                  </button>-->
                </div>
              </div>
              <div class="control">
                <label
                >Number of Locations <span class="required">*</span></label
                >
                <div class="number-input">
                  <input type="number" v-model.number="controls.locations" @input="checkEnterpriseLimit()"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </label>

      <label class="plan-card">
        <input
          type="radio"
          name="scorching-plan"
          value="scorching"
          v-model="selected"
        />
        <div class="card-inner">
          <div class="top">
            <div class="plan-info">
              <img src="@/assets/icons/scorching-plan.svg" alt="Sun Icon"/>
              <h3>Scorching Plan</h3>
            </div>
            <div class="plan-right">
              <p>
                Access our full training library, including compliance courses
                like Food & Alcohol and Sexual Harassment.
              </p>
              <div class="d-flex flex-column price-container">
                <div class="price">$2.49 - 2.99/</div>
                <div class="sub">Per user, per month.</div>
              </div>
            </div>
          </div>
          <div class="plan-controls">
            <div class="control-grid">
              <div class="control">
                <label>Number of Users <span class="required">*</span></label>
                <div class="number-input">
                  <input type="number" v-model.number="controls.users" @input="checkEnterpriseLimit()"/>
                </div>
              </div>
              <div class="control">
                <label>Number of Locations <span class="required">*</span></label>
                <div class="number-input">
                  <input type="number" v-model.number="controls.locations" @input="checkEnterpriseLimit()"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </label>

<!--      <div class="plan-card enterprise">-->
<!--        <div class="plan-left">-->
<!--          <img src="@/assets/icons/enterprize-plan.svg" alt="Bag Icon"/>-->
<!--          <h3>Enterprise Plan</h3>-->
<!--        </div>-->
<!--        <div class="plan-right">-->
<!--          <p>-->
<!--            Access our full training library, including compliance courses like-->
<!--            Food & Alcohol and Sexual Harassment.-->
<!--          </p>-->
<!--          <button class="contact-btn py-3">Contact Us</button>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </section>
</template>

<script>
export default {
  name: "PlanSelector",
  emits: ["plan-change" ,"open-enterprise-modal"],
  props: {
    plans: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selected: null,
      controls: {
        users: 1,
        locations: 1,
      },
    };
  },
  watch: {
    selected(newVal) {
      this.emitPlanChange(newVal);
    },
    controls: {
      deep: true,
      handler() {
        this.emitPlanChange(this.selected);
      },
    },
  },
  mounted() {
    if (this.selected) {
      this.emitPlanChange(this.selected);
    }
  },
  methods: {
    emitPlanChange(planKey) {
      if (!planKey) return;
      const plan = this.plans[planKey];
      this.$emit("plan-change", {
        plan: planKey,
        name: plan.name,
        courses: plan.courses,
        controls: { ...this.controls },
      });
    },
    increment(field) {
      this.controls[field] = Number(this.controls[field] || 1) + 1;
    },
    decrement(field) {
      this.controls[field] = Math.max(1, Number(this.controls[field] || 1) - 1);
    },
    checkEnterpriseLimit() {
      const { users, locations } = this.controls;
      if (users > 2500 || locations > 2500) {
        this.controls.users = Math.min(users, 2500);
        this.controls.locations = Math.min(locations, 2500);
        this.$emit("open-enterprise-modal");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

h2,
h3,
h4,
h5,
p {
  margin: 0;
}

.plan-selector {
  position: relative;
  margin-top: 30px;
  margin-bottom: 30px;

  .plan-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    .title {
      font-size: 20px;
      line-height: 25px;
      font-weight: 700;
      margin-bottom: 20px;
      color: #252525;
      display: flex;
      align-items: center;

      .play-icon {
        display: none;
      }
    }

    .step-badge {
      position: absolute;
      right: 0;
      top: -7px;
      background: #fff0ea;
      padding: 8px 10px;
      border-radius: 6px;
      font-size: 10px;
      line-height: 23px;
      font-weight: 700;
      color: #252525;
    }
  }

  .plans {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .plan-card,
  .plan-card label {
    display: block;
    padding: 0;
    position: relative;
  }

  .plan-card input[type="radio"] {
    display: none;
  }

  .card-inner {
    border-radius: 12px;
    border: 2px solid rgba(235, 36, 36, 0.06);
    background: #fff;
    position: relative;
    padding: 12px;
    // &:hover {
    //   background: rgba(0, 0, 0, 0.1);
    //   cursor: pointer;
    // }
    .top {
      display: flex;
      flex-direction: column;
      gap: 12px;

      .plan-info {
        display: flex;
        align-items: center;
        gap: 12px;

        h3 {
          font-size: 22px;
          line-height: 28px;
          font-weight: 600;
          color: #000000;
        }
      }

      .plan-right {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;

        p {
          font-size: 12px;
          line-height: 15px;
          color: #252525;
        }

        .price-container {
          flex: 1;
          min-width: fit-content;
          justify-content: flex-end;
          align-items: flex-end;

          .price {
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
            color: #252525;
            text-align: right;
            width: fit-content;
          }

          .sub {
            font-size: 10px;
            color: rgba(37, 37, 37, 0.6);
          }
        }
      }
    }
  }

  /* selected styles */
  .plan-card input[type="radio"]:checked + .card-inner {
    border: 2px solid #eb1a26;
    box-shadow: 0 10px 30px rgba(255, 106, 74, 0.12);
    transform: translateY(-2px);
  }

  /* radio indicator top-right */
  .plan-card .card-inner::after {
    content: "";
    position: absolute;
    right: 18px;
    top: 18px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 2px solid rgba(200, 200, 200, 0.6);
    background: transparent;
  }

  .plan-card input[type="radio"]:checked + .card-inner::after {
    background: radial-gradient(circle at 30% 30%, #fff, #ffd6cc);
    border: 4px solid #ff6a4a;
  }

  .plan-controls {
    margin-top: 12px;
    width: 100%;
    max-height: 0;
    overflow: hidden;
    transition: max-height 260ms ease;
  }

  .plan-card input[type="radio"]:checked + .card-inner .plan-controls {
    max-height: 240px; /* enough to reveal controls */
  }

  .control-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .control {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1 1 0;
    background: #fff;
    border-radius: 8px;
    padding: 8px;
    border: 1px solid rgba(0, 0, 0, 0.06);

    label {
      font-size: 10px;
      line-height: 13px;
      font-weight: 700;
      display: block;
      margin-bottom: 0px;
    }

    .number-input {
      display: inline-flex;
      align-items: center;
      border-radius: 5px;
      overflow: hidden;
      border: 1px solid rgba(0, 0, 0, 0.5);
      max-width: 100px;
      height: 27px;

      button {
        width: 19px;
        height: 19px;
        border: none;
        background: transparent;
        color: #ff6a4a;
        font-weight: 700;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      input {
        width: 75px;
        height: 20px;
        font-size: 12px;
        border: none;
        text-align: center;

        &:focus {
          outline: none;
        }
      }
    }
  }

  .plan-card.popular {
    border-color: rgba(235, 36, 36, 0.12);
  }

  .plan-card.popular .badge {
    position: absolute;
    right: 60px;
    top: -0px;
    width: 80px;
    background: linear-gradient(90deg, #ff8a56, #ff4a36);
    color: #fff;
    padding: 4px 8px;
    border-radius: 10px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    font-weight: 700;
    font-size: 7px;
  }

  .plan-card.enterprise {
    border-radius: 12px;
    border: 2px solid rgba(235, 36, 36, 0.06);
    background: #fff;
    padding: 18px;

    .plan-left {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .plan-right {
      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        max-width: 483px;
        font-size: 12px;
        color: #252525;
      }

      .contact-btn {
        background: linear-gradient(90deg, #ff8a56 0%, #ff4a36 100%);
        color: #fff;
        border: none;
        font-size: 12px;
        line-height: 15px;
        padding: 15px 67px;
        border-radius: 10px;
        font-weight: 700;
        cursor: pointer;
        max-width: 226px;
      }
    }
  }
}

@media (min-width: 768px) {
  .plan-selector {
    margin-top: 60px;

    .plans {
      gap: 20px;
    }

    .plan-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;

      .title {
        font-size: 32px;
        line-height: 40px;
        font-weight: 700;
        margin-bottom: 20px;
        color: #252525;
        display: flex;
        align-items: center;

        .play-icon {
          color: #eb1a26;
          margin-left: 10px;
          font-size: 24px;
        }
      }

      .step-badge {
        position: absolute;
        right: 0;
        top: 0;
        background: #fff0ea;
        padding: 10px 14px;
        border-radius: 16px;
        font-size: 18px;
        line-height: 23px;
        font-weight: 700;
        color: #252525;
      }
    }

    .control-grid {
      flex-direction: row;
      gap: 12px;
    }

    .card-inner {
      border-radius: 12px;
      border: 2px solid rgba(235, 36, 36, 0.06);
      background: #fff;
      position: relative;
      padding: 18px;

      .top {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .plan-info {
          display: flex;
          align-items: center;
          gap: 12px;

          h3 {
            font-size: 22px;
            line-height: 28px;
            font-weight: 600;
            color: #000000;
          }
        }

        .plan-right {
          display: flex;
          align-items: center;
          justify-content: space-between;

          p {
            font-size: 12px;
            line-height: 15px;
            color: #252525;
            max-width: 483px;
          }

          .price-container {
            flex: 1;
            align-items: flex-end;

            .price {
              font-weight: 600;
              font-size: 24px;
              line-height: 30px;
              color: #252525;
            }

            .sub {
              font-size: 12px;
              color: rgba(37, 37, 37, 0.6);
              text-align: left;
            }
          }
        }
      }
    }

    .plan-card.popular .badge {
      position: absolute;
      right: 110px;
      top: -0px;
      width: 128px;
      background: linear-gradient(90deg, #ff8a56, #ff4a36);
      color: #fff;
      padding: 6px 12px;
      border-radius: 16px;
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
      font-weight: 700;
      font-size: 12px;
    }

    .control {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1 1 0;
      background: #fff;
      border-radius: 8px;
      padding: 12px;
      border: 1px solid rgba(0, 0, 0, 0.06);

      label {
        font-size: 15px;
        display: block;
        margin-bottom: 0px;
      }

      .number-input {
        height: 34px;

        button {
          width: 30px;
          height: 30px;
        }

        input {
          width: 75px;
          height: 30px;
          border: none;
          text-align: center;

          &:focus {
            outline: none;
          }
        }
      }
    }
  }
}
</style>
